<mat-card
    class="approval-summary mat-elevation-z0"
    role="region"
    [attr.aria-label]="'BuySellApprovalSummary' | translate: {Default: 'Buy/Sell Approval Summary'}">
    <mat-card-content>
        <dl class="detail-list">
            <div class="detail-row">
                <dt class="label" appLocalizationPopupDirective localizationCode="BuySellApprovalStatus">
                    {{ 'BuySellApprovalStatus' | translate: {Default: "Status"} }}
                </dt>
                <dd class="value">
                    <mat-chip-set
                        *ngIf="buySellApproval"
                        [attr.aria-label]="'BuySellApprovalStatus' | translate: {Default: 'Status'}">
                        <mat-chip
                            [ngClass]="{
                                'red-chip': buySellApproval.status?.id === 'DENIED',
                                'green-chip': buySellApproval.status?.id === 'APPROVED',
                                'orange-chip': buySellApproval.status?.id === 'QUEUED',
                                'blue-chip': buySellApproval.status?.id === 'PENDING_APPROVAL'
                            }"
                            [attr.aria-label]="buySellApproval.status?.text"
                            role="status"
                        >{{ buySellApproval.status?.text }}</mat-chip>
                    </mat-chip-set>
                </dd>
            </div>

            <div class="detail-row">
                <dt class="label" appLocalizationPopupDirective localizationCode="BuySellRequestOn">
                    {{ 'BuySellRequestOn' | translate: {Default: "Request On"} }}
                </dt>
                <dd class="value">{{buySellApproval?.version?.createdOn | date: 'longDate'}}</dd>
            </div>

            <div class="detail-row">
                <dt class="label" appLocalizationPopupDirective localizationCode="BuySellSubmittedBy">
                    {{ 'BuySellSubmittedBy' | translate: {Default: "Submitted By"} }}
                </dt>
                <dd class="value">
                    <app-employee-label [employee]="buySellApproval?.version?.createdBy"></app-employee-label>
                </dd>
            </div>

            <div class="detail-row">
                <dt class="label" appLocalizationPopupDirective localizationCode="BuySellRequestType">
                    {{ 'BuySellRequestType' | translate: {Default: "Request Type"} }}
                </dt>
                <dd class="value">
                    {{ selectedType === 'BUY'
                        ? ('Buy' | translate: {Default: 'Buy'})
                        : ('Sell' | translate: {Default: 'Sell'}) }}
                </dd>
            </div>

            <div class="detail-row">
                <dt class="label" appLocalizationPopupDirective localizationCode="BuySellRequestedHours">
                    {{ 'BuySellRequestedHours' | translate: {Default: "Requested Hours"} }}
                </dt>
                <dd class="value">{{ buySellPlanEmployee?.hours }}</dd>
            </div>

            <div class="detail-row">
                <dt class="label" appLocalizationPopupDirective localizationCode="BuySellHourlyRate">
                    {{ 'BuySellHourlyRate' | translate: {Default: "Hourly Rate"} }}
                </dt>
                <dd class="value">{{ compensation?.payRateCurrency?.id | currencyDisplay: buySellPlanEmployee?.hourlyCost }}</dd>
            </div>

            <div class="detail-row">
                <dt
                    *ngIf="selectedType === 'BUY'"
                    class="label"
                    appLocalizationPopupDirective localizationCode="SalaryDeduction">
                    {{ 'SalaryDeduction' | translate: {Default: "Salary Deduction"} }}
                </dt>
                <dt
                    *ngIf="selectedType === 'SELL'"
                    class="label"
                    appLocalizationPopupDirective localizationCode="SalaryAddition">
                    {{ 'SalaryAddition' | translate: {Default: "Salary Addition"} }}
                </dt>
                <dd class="value">
                    {{ compensation?.payRateCurrency?.id | currencyDisplay: buySellPlanEmployee?.hours * buySellPlanEmployee?.hourlyCost }}
                </dd>
            </div>
        </dl>

        <div
            class="action-buttons"
            *ngIf="buySellApproval?.status?.id === 'PENDING_APPROVAL'"
            role="group"
            [attr.aria-label]="'ApprovalActions' | translate: {Default: 'Approval Actions'}">
            <button
                color="warn"
                mat-raised-button
                appLocalizationPopupDirective localizationCode="DenyButton"
                [attr.aria-label]="'DenyButton' | translate: {Default: 'Deny'}"
                appPreventDoubleClick
                (throttledClick)="openApproveDenyDialog('deny')">
                <mat-icon class="material-icons-outlined" aria-hidden="true">cancel</mat-icon>
                {{ 'DenyButton' | translate: {Default: "Deny"} }}
            </button>
            <button
                class="green-chip"
                mat-raised-button
                appLocalizationPopupDirective localizationCode="ApproveButton"
                [attr.aria-label]="'ApproveButton' | translate: {Default: 'Approve'}"
                appPreventDoubleClick
                (throttledClick)="openApproveDenyDialog('approve')">
                <mat-icon class="material-icons-outlined" aria-hidden="true">check_circle</mat-icon>
                {{ 'ApproveButton' | translate: {Default: "Approve"} }}
            </button>
        </div>
    </mat-card-content>
</mat-card>